import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { adminApi } from "@/lib/api";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (ev) => {
    ev.preventDefault();
    if (!username || !password) {
      toast.error("請輸入帳號與密碼");
      return;
    }
    try {
      setLoading(true);
      const res = await adminApi.login(username, password);
      localStorage.setItem("admin_token", res.access_token);
      toast.success("登入成功");
      navigate("/admin", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail || "登入失敗，請檢查帳號密碼";
      toast.error(detail);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[hsl(var(--background))] px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="mx-auto w-10 h-10 rounded-full bg-[hsl(var(--brass))]/15 border border-[rgba(176,141,87,0.4)] flex items-center justify-center">
            <Lock className="w-4 h-4 text-[hsl(var(--brass))]" />
          </div>
          <h1 className="font-serif-tc mt-4 text-2xl font-bold text-[hsl(var(--foreground))]">后台登入</h1>
          <p className="mt-1 text-sm text-[hsl(var(--muted-foreground))]">Webinar 管理後台</p>
        </div>
        <form onSubmit={onSubmit} className="rounded-2xl bg-[hsl(var(--card))] border border-[hsl(var(--border))] p-6 shadow-[0_10px_30px_rgba(14,27,42,0.06)] space-y-4">
          <div>
            <Label htmlFor="username" className="text-sm">帳號</Label>
            <Input
              id="username"
              data-testid="admin-login-username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="mt-2 h-11 rounded-xl"
              autoComplete="username"
            />
          </div>
          <div>
            <Label htmlFor="password" className="text-sm">密碼</Label>
            <Input
              id="password"
              data-testid="admin-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-11 rounded-xl"
              autoComplete="current-password"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full h-11 rounded-xl bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:bg-[hsl(var(--primary))]/90 transition-[background-color]"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            登入
          </Button>
        </form>
      </div>
    </div>
  );
}
